import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { SharedModule } from '../../shared/shared.module';
import { BaselineSharedModule } from 'baseline-lib';
import { VirtualBetslipPage } from './virtual-betslip';


@NgModule({
  declarations: [
    VirtualBetslipPage,
  ],
  imports: [
    IonicPageModule.forChild(VirtualBetslipPage),
    SharedModule,
    BaselineSharedModule
  ],
})
export class VirtualBetslipPageModule {}



// WEBPACK FOOTER //
// ./src/app/virtual-sports/virtual-bet-slip/virtual-betslip.module.ts